import ConfirmationModel from '../Modal/confirmationModel';
import './academy.css'
import React, { useState, useEffect } from 'react';

const ModuleExcercise = ({ id, isOpen, onClose }) => {
    if (!isOpen) return null;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0);
    const submitLogs = async (moduleId, excerciseName) => {
        var url = `/api/Course/SubmitLog`
        // Define the parameters you want to pass in the body
        var parameters = {
            isModuleExcercise: true,
            moduleId: moduleId,
            excerciseName: excerciseName,
            p_ID: localStorage.getItem('MT_ID')

            // ... add more parameters as needed
        };
        var body = JSON.stringify(parameters);
        await fetch(url, {
            method: 'POST', // or 'PUT' if you are updating data
            headers: {
                'Content-Type': 'application/json'
                // Add any other headers you need here
            },
            body: body
        }).then(response => response.json())
            .then(d => {
                console.log('sadfasdf');
            })

    }
    useEffect(() => {
        if (isOpen) {
            const fetchData = async () => {
                setLoading(true);
                var PID = localStorage.getItem('MT_ID');
                try {
                    const response = await fetch(`/api/Course/GetExcercises/${id}/${PID}`);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const result = await response.json();
                    setData(result);

                    if (result.length > 0) {
                        submitLogs(id, result[0].excerciseName);
                    }
                    console.log()
                } catch (e) {
                    setError(e.message);
                } finally {
                    setLoading(false);
                }
            };

            fetchData();
        }
    }, [isOpen]);


    const showConfirmation = () => {
        onClose()
    };
    const setSelectedTabs = (id, excerciseName, index) => {
        setSelectedTab(index);
        setTimeout(() => {
            if (data[index] && data[index].values) {
                var jsonData = JSON.parse(data[index].values);
                debugger
                Object.keys(jsonData).forEach(key => {
                    document.getElementById(key).value = jsonData[key];
                });
            }
        }, 1000);
        submitLogs(id, excerciseName)
    };
    const saveHTML = async (excerciseId) => {
        // Define the parameters you want to pass in the body
        var container = document.getElementById("HTMLExcercise");

        // Get the inner HTML content
        var innerHTMLContent = container.innerHTML;

        // Create a temporary element to parse inner HTML
        var tempElement = document.createElement('div');
        tempElement.innerHTML = innerHTMLContent;

        // Find all input elements
        var inputElements = tempElement.querySelectorAll('input');

        // Iterate over input elements to get their values
        var inputValues = {};
        inputElements.forEach(function (input) {
            inputValues[input.id] = document.getElementById(input.id).value;
        });
        setLoading(true)
        var parameters = {
            html: JSON.stringify(inputValues),
            id: excerciseId,
            p_ID: localStorage.getItem('MT_ID')

            // ... add more parameters as needed
        };
        var body = JSON.stringify(parameters);
        await fetch(`/api/Course/UpdateExcercise`, {
            method: 'POST', // or 'PUT' if you are updating data
            headers: {
                'Content-Type': 'application/json'
                // Add any other headers you need here
            },
            body: body
        }).then(response => response.json())
            .then(d => {
                setLoading(false)
            })

    };
    return (
        <div className="modal-backdrop">
            <div className="modal-content-Quiz">
                {<button onClick={showConfirmation} className="close-button">X</button>}
                {loading && <p>Loading...</p>}
                {error && <p>Error: {error}</p>}
                {data && <div style={{ position: 'relative', marginTop: '20px' }}>
                    <div style={{ position: 'relative', marginTop: '20px' }}>
                        <div className="tabs">
                            {data.map((item, index) => (
                                <button
                                    key={index}
                                    className={`tab-item ${index === selectedTab ? 'active' : ''}`}
                                    onClick={() => setSelectedTabs(id, item.excerciseName, index)}
                                >
                                    {item.excerciseName}
                                </button>
                            ))}
                        </div>
                        <div className="tab-content">
                            {data[selectedTab] && <div>
                                {data[selectedTab].type == 1 &&
                                    <div>
                                        {data[selectedTab].path && <iframe src={`/api/Course/GetTopicFile/${data[selectedTab].path}` + '#pagemode=none'} width="100%" height="700px" />}
                                    </div>
                                }
                                {data[selectedTab].type == 2 &&
                                    <div >
                                        {
                                            data[selectedTab].html && <div id='HTMLExcercise' dangerouslySetInnerHTML={{ __html: data[selectedTab].html }}></div>
                                        }
                                    </div>
                                }
                            </div>}
                        </div>
                        <div>
                            {data[selectedTab].type == 2
                                &&
                                <button disabled={loading}
                                    onClick={() => {
                                        saveHTML(data[selectedTab].id)
                                    }}
                                    style={{ backgroundColor: 'green', float: 'right', marginTop: '10px', color: 'white' }}
                                    className={`tab-item `}
                                >
                                    Save
                                </button>}
                        </div>
                    </div>
                </div>}
            </div>
        </div >
    );
};
export default ModuleExcercise;